import { memo, useRef } from 'react';
import FloatAnimation from './FloatAnimation';
import RainAnimation from './RainAnimation';

interface IconProps {
  className?: string;
}

function ShowersIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-showers"
    >
      <path
        d="M55.0684 23C67.2823 23 77.1836 32.9013 77.1836 45.1152C77.1836 45.5608 77.1695 46.0033 77.1436 46.4424H84.3457C93.6283 46.4424 101.154 53.9674 101.154 63.25C101.154 72.5325 93.6282 80.0576 84.3457 80.0576H34.8076C25.5251 80.0576 18.0002 72.5325 18 63.25C18 54.5784 24.5669 47.4402 32.999 46.5381C32.9691 46.0676 32.9531 45.5932 32.9531 45.1152C32.9531 32.9012 42.8544 23 55.0684 23Z"
        fill="white"
        fillOpacity="0.7"
      >
        <FloatAnimation />
      </path>
      <path
        d="M36.6587 76.3291C37.0292 75.5881 37.9304 75.2877 38.6714 75.6582C39.4123 76.0287 39.7127 76.9299 39.3423 77.6709L30.3423 95.6709C29.9718 96.4118 29.0705 96.7123 28.3296 96.3418C27.5886 95.9713 27.2882 95.07 27.6587 94.3291L36.6587 76.3291Z"
        fill="white"
      >
        <RainAnimation delay={0} />
      </path>
      <path
        d="M47.6587 76.3291C48.0292 75.5881 48.9304 75.2877 49.6714 75.6582C50.4123 76.0287 50.7127 76.9299 50.3423 77.6709L41.3423 95.6709C40.9718 96.4118 40.0705 96.7123 39.3296 96.3418C38.5886 95.9713 38.2882 95.07 38.6587 94.3291L47.6587 76.3291Z"
        fill="white"
      >
        <RainAnimation delay={0.3} />
      </path>
      <path
        d="M69.6587 76.3291C70.0292 75.5881 70.9304 75.2877 71.6714 75.6582C72.4123 76.0287 72.7127 76.9299 72.3423 77.6709L63.3423 95.6709C62.9718 96.4118 62.0705 96.7123 61.3296 96.3418C60.5886 95.9713 60.2882 95.07 60.6587 94.3291L69.6587 76.3291Z"
        fill="white"
      >
        <RainAnimation delay={0.6} />
      </path>
      <path
        d="M58.6587 76.3291C59.0292 75.5881 59.9304 75.2877 60.6714 75.6582C61.4123 76.0287 61.7127 76.9299 61.3423 77.6709L52.3423 95.6709C51.9718 96.4118 51.0705 96.7123 50.3296 96.3418C49.5886 95.9713 49.2882 95.07 49.6587 94.3291L58.6587 76.3291Z"
        fill="white"
      >
        <RainAnimation delay={0.9} />
      </path>
      <path
        d="M80.6587 76.3291C81.0292 75.5881 81.9304 75.2877 82.6714 75.6582C83.4123 76.0287 83.7127 76.9299 83.3423 77.6709L74.3423 95.6709C73.9718 96.4118 73.0705 96.7123 72.3296 96.3418C71.5886 95.9713 71.2882 95.07 71.6587 94.3291L80.6587 76.3291Z"
        fill="white"
      >
        <RainAnimation delay={1.2} />
      </path>
    </svg>
  );
}

export default memo(ShowersIcon);
